/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import appConfig from 'config';
import { sessionProvider } from 'utils';
import { useAuth, useIntercom } from 'hooks';

function PrivateRoute({ children, authenticatedOnly, redirectTo, role, ...rest }) {
  const { isAuthenticated, id, user } = useAuth();
  const { update, missingData } = useIntercom();
  const isRoleValid = sessionProvider.checkRole(role);
  const shouldRedirect = authenticatedOnly ? !isAuthenticated : isAuthenticated;

  if (!_.isEmpty(user) && missingData.current) {
    update({ ...user, ...{ accountId: id } });
  }

  if (isAuthenticated && !isRoleValid) {
    window.location.replace(appConfig.oldPortalUrl);
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        shouldRedirect ? (
          <Redirect
            to={{
              pathname: redirectTo,
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
}

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  role: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  redirectTo: PropTypes.string.isRequired,
  authenticatedOnly: PropTypes.bool.isRequired,
};

PrivateRoute.defaultProps = {
  role: null,
};

export default PrivateRoute;
